/**
 * The Needs you section head, shared by the tab's own asks panel and the Inbox-backed one
 * (decision/lanes-slots.tsx): one count, amber only when something blocks a run, never a frame.
 * At zero it is the whole section: "✓ Nothing needs you".
 */
import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { homeHref } from '../../lib/ia.js'
import { Glyph } from './glyphs.js'

export function AsksHead({
  projectId,
  blocking,
  rows,
  action,
}: {
  projectId: string
  /** Asks that block a run (the tab badge's number). */
  blocking: number
  /** Everything listed, blocking or not. */
  rows: number
  /** Right-hand action ("Decide all 3"). */
  action?: ReactNode
}) {
  const n = blocking || rows
  return (
    <div className="lk-section-h">
      <h2 id="lk-asks-h">
        {n ? (
          <>
            {blocking ? <Glyph kind="wait" /> : null}
            {blocking ? 'Needs you' : 'Needs you, when convenient'}
          </>
        ) : (
          <>
            <Glyph kind="ok" />
            Nothing needs you
          </>
        )}
      </h2>
      {n ? (
        <Link
          className={`lk-count${blocking ? ' is-wait' : ''}`}
          to={homeHref({ v: 'needs', project: projectId })}
          aria-label={
            blocking
              ? `${blocking} ${blocking === 1 ? 'decision needs' : 'decisions need'} you: open in Home`
              : `${rows} when convenient: open in Home`
          }
        >
          {n}
        </Link>
      ) : null}
      {n && action ? <span className="lk-section-h__act">{action}</span> : null}
    </div>
  )
}
